import { useEffect, useRef, useState } from "react";

import ArrowUpIcon from "../../assets/img/icons/arrow_up_white.svg";
import { smoothScrollTo } from "../../utils/scrollUtils";

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const lastScrollY = useRef<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.pageYOffset;

      if (currentScrollY < lastScrollY.current && currentScrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    smoothScrollTo(0, 300);
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 bg-dark-blue-2 rounded-[1.25rem] text-white p-4 shadow-lg transition-all duration-300 ease-in-out hover:scale-110 focus:outline-none border-light"
          aria-label="Scroll to top"
          style={{ borderWidth: "1px" }}
        >
          <img src={ArrowUpIcon} alt="" className="w-6 h-6" />
        </button>
      )}
    </>
  );
}

export default ScrollToTopButton;
